import { Controller } from '@hotwired/stimulus'
import { loadApexCharts } from '../utils/chart_loader'

export default class extends Controller {
  static values = { data: Array, name: String, categories: Array }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  async initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const ApexCharts = (await loadApexCharts()).default
    const maxValue = Math.max(...this.dataValue)

    const options = {
      colors: ['#FBBF24'],
      chart: {
        type: 'bar',
        toolbar: { show: false },
        height: '100%',
        parentHeightOffset: 0,
        fontFamily: 'Inter, system-ui, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 600,
          animateGradually: { enabled: true, delay: 50 },
        },
      },
      title: {
        text: this.nameValue,
        align: 'center',
        style: {
          fontSize: '16px',
          fontWeight: '600',
          color: '#1f2937',
        },
      },
      series: [
        {
          name: this.nameValue,
          data: this.dataValue,
        },
      ],
      xaxis: {
        categories: this.categoriesValue,
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: {
          style: {
            colors: '#9ca3af',
            fontSize: '12px',
            fontWeight: 500,
          },
        },
      },
      yaxis: {
        max: Math.ceil(maxValue * 1.15),
        labels: { show: false },
      },
      grid: {
        show: false,
        padding: { top: -10, bottom: -5, left: 0, right: 0 },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '13px',
          fontWeight: '600',
          colors: ['#374151'],
        },
        background: { enabled: false },
      },
      tooltip: {
        enabled: true,
        intersect: false,
        theme: 'light',
        style: { fontSize: '13px' },
        y: {
          formatter: (value) => `${value} clientes`,
        },
      },
      plotOptions: {
        bar: {
          distributed: false,
          columnWidth: '55%',
          borderRadius: 8,
          borderRadiusApplication: 'end',
          dataLabels: {
            position: 'top',
          },
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.2,
          opacityFrom: 1,
          opacityTo: 0.85,
          stops: [0, 100],
        },
      },
      states: {
        hover: {
          filter: { type: 'darken', value: 0.9 },
        },
      },
      legend: { show: false },
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
